const parseOptionalInt = (value: string): number | null => {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return null;
  const parsed = parseInt(trimmed, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

const parseOptionalNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const normalizePricePoint = (value: number): number => {
  // Collapse float noise (e.g. 4.999999999 -> 5.00) so same price points aggregate.
  return Math.round(value * 100) / 100;
};

export const resolveTicketPricePoint = (
  ticket: any,
  gamesData: Map<string, number> | null | undefined,
): number | null => {
  const rawGameId = ticket?.game ?? ticket?.game_id;
  const rawGameIdText = rawGameId === null || rawGameId === undefined ? '' : String(rawGameId).trim();
  const gameId = rawGameIdText.includes('-') ? rawGameIdText.split('-')[0].trim() : rawGameIdText;

  const directTicketPrice = parseOptionalNumber(ticket?.ticketPrice);
  const parsedCandidate = directTicketPrice ?? parseOptionalNumber(gamesData && gameId ? gamesData.get(gameId) : null);
  const parsed = parsedCandidate;
  if (parsed !== null && parsed > 0) {
    return normalizePricePoint(parsed);
  }

  return null;
};

export const calculateTicketsSoldFromRange = (
  range: unknown,
  ticketsPerPack: unknown,
): number => {
  return calculateTicketsSoldFromRangeResult(range, ticketsPerPack).sold;
};

export const calculateTicketsSoldFromRangeResult = (
  range: unknown,
  ticketsPerPack: unknown,
): { sold: number; isValid: boolean } => {
  if (typeof range !== 'string') return { sold: 0, isValid: false };

  const normalizedRange = range.trim();
  if (!normalizedRange || !normalizedRange.includes('-')) return { sold: 0, isValid: false };

  const [rawStart = '', rawEnd = ''] = normalizedRange.split('-');
  const start = parseOptionalInt(rawStart);
  if (start === null) return { sold: 0, isValid: false };

  const ticketsPerPackNumber = parseOptionalNumber(ticketsPerPack);
  const endText = String(rawEnd ?? '').trim();

  if (!endText) return { sold: 0, isValid: false };

  if (endText.toUpperCase() === 'END') {
    if (!ticketsPerPackNumber) return { sold: 0, isValid: false };
    return {
      sold: Math.max(0, Math.floor(ticketsPerPackNumber) - start),
      isValid: true,
    };
  }

  const end = parseOptionalInt(endText);
  if (end === null) return { sold: 0, isValid: false };

  // When the OCR/editor substitutes END with the full pack size, treat it the same.
  if (ticketsPerPackNumber && end === Math.floor(ticketsPerPackNumber)) {
    return {
      sold: Math.max(0, Math.floor(ticketsPerPackNumber) - start),
      isValid: true,
    };
  }

  return {
    sold: Math.max(0, end - start),
    isValid: true,
  };
};
